import { connect } from 'react-redux';
import { IStateType } from '../../../../store/models/root.interface';
import { closeSideBar, getParams } from '../../../../store/sidebar';
import APIKeyEdit, { DispatchPropsType, MapStatePropsType } from '../organisms/APIKeyEdit';


const mapStateToProps = (state: IStateType) => ({
	params: getParams(state),
});
const mapDispatchToProps = {
	onClose: () => {
		return closeSideBar();
	}
};

export default connect<MapStatePropsType, DispatchPropsType, unknown, IStateType>(
	mapStateToProps,
	mapDispatchToProps
)(APIKeyEdit);
